import { RouteObject, Outlet } from "react-router-dom";
import { lazyWithReload } from "src/shared/services/lazyWithReload/lazyWithReload";
import RouteProtector from "./RouteProtector";

const MyFollow = lazyWithReload(
  () => import("src/followCompany/features/myFollow/MyFollow"),
);
const SearchCompanyToFollow = lazyWithReload(
  () =>
    import(
      "src/followCompany/features/searchCompanyToFollow/SearchCompanyToFollow"
    ),
);
const Subscribe = lazyWithReload(
  () => import("src/followCompany/features/subscribe/Subscribe"),
);

export const followCompanyPaths: RouteObject = {
  path: "/followCompany",
  element: <Outlet />,
  children: [
    {
      path: "myFollow",
      element: (
        <RouteProtector allowedUsers={["isBusiness", "isNonGemiUser"]}>
          <MyFollow />
        </RouteProtector>
      ),
    },

    {
      path: "searchCompanyToFollow",
      element: (
        <RouteProtector allowedUsers={["isBusiness", "isNonGemiUser"]}>
          <SearchCompanyToFollow />
        </RouteProtector>
      ),
    },
    {
      path: "subscribe",
      element: (
        <RouteProtector allowedUsers={["isBusiness", "isNonGemiUser"]}>
          <Subscribe />
        </RouteProtector>
      ),
    },
  ],
};